var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-chart-container h-100 w-100 height-override"},[_vm._t("content"),(_vm.dataSet.length)?_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.formattedChartData,"options":_vm.getChartOptions}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }